import { Component, DestroyRef, OnInit, inject, signal } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router, RouterLink } from "@angular/router";
import { VoltaAuthService } from "@core/auth/volta-auth.service";
import { AccessService } from "@core/client/access.service";
import { CompanyService } from "@core/client/company.service";
import { UserService } from "@core/client/user.service";
import { VoltaCommon } from "@core/common/volta-common";
import { FeatureFlagsService } from "@core/feature-flags/page-feature-flags.service";
import { Module, NavigationVisibility } from "@core/navigation/navigation.model";
import { NavigationService } from "@core/navigation/navigation.service";
import { UIService } from "@core/ui/ui.service";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { UserImageComponent } from "@identity/components/user-image/user-image.component";
import { VoltaSweetAlertService } from "@shared/services/volta-sweet-alert/volta-sweet-alert.service";
import { filter, firstValueFrom } from "rxjs";
import { NavigationItemComponent } from "../navigation-item/navigation-item.component";
import { NavigationModuleIconComponent } from "../navigation-module-icon/navigation-module-icon.component";

@Component({
    selector: 'app-navigation-bar',
    imports: [NavigationItemComponent, FontAwesomeModule, RouterLink, UserImageComponent, NavigationModuleIconComponent],
    templateUrl: './navigation-bar.component.html',
    styleUrl: './navigation-bar.component.scss'
})
export class NavigationBarComponent implements OnInit{

    VoltaCommon = VoltaCommon;
    navigationVisibility = NavigationVisibility;
    Modules = Module;
    
    private accessService = inject(AccessService);
    authService = inject(VoltaAuthService);
    companyService = inject(CompanyService);
    userService = inject(UserService);
    uiService = inject(UIService);
    router = inject(Router);
    destroyRef = inject(DestroyRef);
    activatedRoute = inject(ActivatedRoute);
    private swalService = inject(VoltaSweetAlertService);
    private navigationService = inject(NavigationService);
    featureFlagsService = inject(FeatureFlagsService);

    navData = signal(this.navigationService.navigation());
    selectedIndex = this.uiService.navBarIndex;
    isDrawerOpen = this.uiService.navBarOpen;
    isExpanded = this.uiService.isNavBarExpanded;
    currentModule = signal<string|undefined>(undefined);

    ngOnInit(): void {

        const routerEventsSubscription = this.router.events
        .pipe(
            filter((event) => event instanceof NavigationEnd)
        )
        .subscribe({
            next: () => {
                this.currentModule.set(this.navigationService.getCurrentModule(this.activatedRoute));
            }
        });

        //Update navigation if license changes
        const accessLicenseSubscription = this.accessService.license$.subscribe({
            next:(value) => {
                this.navData.set(this.navigationService.navigation());
            }
        })

        //Update navigation if permissions changes
        const accessPermissionsSubscription = this.accessService.permissions$.subscribe({
            next:(value) => {
                this.navData.set(this.navigationService.navigation());
            }
        })

        this.destroyRef.onDestroy(() => {
            routerEventsSubscription.unsubscribe();
            accessLicenseSubscription.unsubscribe();
            accessPermissionsSubscription.unsubscribe();
        })
    }
    
    onSelectNavItem(index:number){
        if(this.selectedIndex() == index){
            this.uiService.setNavBarIndex(undefined);
            this.uiService.setNavBarOpen(false);
        }
        else{
            this.uiService.setNavBarIndex(index);
            this.uiService.setNavBarOpen(true);
        }
    }
    
    onLogOut(){
        this.swalService.fireLoading({message: "Logging you out, please wait."});

        firstValueFrom(this.userService.userLogOut())
        .then((response) => {
            this.swalService.close();
        })
    }
}
